export default {
  newTitle: 'Nueva Simulación de Presupuesto',
  create: 'Crear',
  name: 'Nombre',
  startDate: 'Fecha de Inicio',
  endDate: 'Fecha de Fin',
  mixMode: 'Modo del Mix',
  free: 'Libre',
  frozen: 'Fijo',
  freeDesc: 'El optimizador elige el mejor mix en cada presupuesto (un Plan Optimizer por presupuesto).',
  frozenDesc: 'Cada presupuesto mantiene el mix ingresado abajo (un Plan Calculator por presupuesto).',
  budgetGrid: 'Grilla de Presupuestos',
  referenceBudget: 'Presupuesto de referencia (100%)',
  useHistoricalBudget: 'Usar el gasto histórico ({value})',
  minPct: 'Desde',
  maxPct: 'Hasta',
  points: 'Puntos',
  mixTitle: 'Mix de Medios',
  useHistoricalMix: 'Usar mix histórico',
  total: 'Total',
  mixMustAddUp: 'Las proporciones deben sumar 100%.',
  frozenTimeHint: 'Cada medio reparte su presupuesto en el periodo siguiendo su propio patrón histórico de gasto en los mismos meses (o semanas).',
  nameRequired: 'El nombre es obligatorio',
  mustBeAfterStartDate: 'Debe ser posterior a la fecha de inicio',
  maxAboveMin: 'Debe ser mayor que el inicio de la grilla',
  noPeriods: 'El periodo seleccionado no tiene periodos del modelo.',
  gridTooSmall: 'La grilla necesita al menos 2 presupuestos distintos.',
  createFailed: 'No se pudo crear la simulación de presupuesto. Inténtalo de nuevo.',
  editTitle: 'Editar Simulación de Presupuesto',
  save: 'Guardar',
  editWarning: 'Al guardar se recalculan desde cero todos los presupuestos de la grilla.',
  namePlaceholder: 'p. ej. Escenarios de presupuesto 2027',
  pickDate: 'Elige una fecha',
  pickMode: 'Elige cómo se define el mix en cada presupuesto',
  modelRange: 'Datos del modelo: {from} → {to}',
  periodMonths: '{count} mes | {count} meses',
  periodWeeks: '{count} semana | {count} semanas',
  setupFirst: 'Elige el modo del mix y el periodo para configurar la grilla de presupuestos.',
  historicalSpendHint: 'El gasto histórico del periodo',
  typeAmountHint: 'Ingresa un monto, como 500k o 2m',
  ofReference: 'de la referencia',
  pointsHint: 'Presupuestos a simular, hasta {max}',
  gridPreview: '{count} presupuestos a simular',
  mixIntro: 'Proporción de cada presupuesto por medio',
  historicalShort: 'Histórico {value}%',
  referenceRequired: 'Ingresa un presupuesto de referencia mayor que 0.'
}
